import React from 'react'
import { Trans } from 'react-i18next'

/** Charging sessions table header step component */
export const ChargingSessionsTableStep: React.FC = () => {
  return <Trans i18nKey="emobility.tour.charging-session-table-header" components={{ strong: <strong /> }} />
}
